import {Tag} from '@hconnect/common/components'
import {DateFormat, GridSetting} from '@hconnect/uikit'
import {Grid} from '@mui/material'
import {EventStatusLabel} from '@widgets/common-shift-event'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {HProduceTask} from '../../types'

import {TaskDescription} from './TaskDescription'

const formatAssignees = (assignees: HProduceTask['assignees']) => {
  return assignees?.map(({name}) => name).join(', ') || '-'
}

const regularSize: GridSetting = {
  xs: 12,
  sm: 4,
  md: 6
}

type Props = {
  task: HProduceTask
  timezone: string
}

export const BaseTaskDetails = ({task, timezone}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const translate = (key: string) => t(key)
  return (
    <>
      <Grid container spacing={2}>
        <Grid item {...regularSize}>
          <Tag label={translate('task.label.status')} data-test-id="task-details-status">
            <EventStatusLabel status={task.status} />
          </Tag>
        </Grid>
        <Grid item {...regularSize}>
          <Tag label={translate('task.label.dueDate')} data-test-id="task-details-dueDate">
            <DateFormat date={task.dueDate} timezone={timezone} />
          </Tag>
        </Grid>
        <Grid item {...regularSize}>
          <Tag label={translate('task.label.assignee')} data-test-id="task-details-assignee">
            {formatAssignees(task.assignees)}
          </Tag>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Tag
            label={translate('task.label.description')}
            descriptionSx={{fontWeight: 400, fontSize: 14}}
            data-test-id="task-details-description"
          >
            <TaskDescription description={task.description} />
          </Tag>
        </Grid>
      </Grid>
    </>
  )
}
